import React, {useMemo} from "react";
import {POSITIONS_COLOR} from "../../utils/constants";
import {
    PicksContainer,
    PicksHeader,
    PicksTable,
    Button,
    RemoveButton,
    NumItem
} from './DraftRoomFavouritePicks.styles';

function DraftRoomFavouritePicks(props){

    const pickedPositions=useMemo(()=>{
        const allPositions =props.pickedPlayers.map(item=>item.position);
        return [...new Set(allPositions)];
    }, [props.pickedPlayers]);

    const handleRemove = (id) => {
        props.setPickedPlayers(prev => prev.filter(player => player.id !== id));
    };


    return(
        <PicksContainer>
            <PicksHeader>
                <div className={"tit"}>Draft Needs</div>
                <div className={"positions"}>
                    {pickedPositions.map((item, idx) => {
                        const id = idx + 1;
                        return (
                            <NumItem
                                key={id}
                                backColor={POSITIONS_COLOR[item.split(' ')[0]]}
                            >
                                <span>{item.split(' ')[0]}</span>
                            </NumItem>
                        );
                    })}
                </div>
            </PicksHeader>
            <PicksTable>
                <thead>
                <tr>
                    <th>BPA</th>
                    <th>Player</th>
                    <th>Pos</th>
                    <th>School</th>
                    <th></th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {props?.pickedPlayers?.map((p, index) => (
                    <tr key={p.id}>
                        <td>{index + 1}</td>
                        <td>{p.player}</td>
                        <td>{p.position}</td>
                        <td>{p.college}</td>
                        <td>
                            <Button
                                onClick={() => {
                                    props.onAddPlayer({
                                        id: p.id,
                                        player: p.player,
                                        position: p.position,
                                        college: p.school,
                                        ranking:p.ranking
                                    });
                                }}
                            >
                                Draft
                            </Button>
                        </td>
                        <td>
                            <RemoveButton onClick={() => handleRemove(p.id)}>
                                Remove
                            </RemoveButton>
                        </td>
                    </tr>
                ))}
                </tbody>
            </PicksTable>
    </PicksContainer>
    )
}


export default DraftRoomFavouritePicks;





